import { slugs } from '@/constants/slugs'

export interface NoFeesValuesType {
  video?: string
  image?: string
  bgColor: string
  large: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  medium: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  small: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  experimentValues?: {
    video?: string
    image?: string
    bgColor?: string
  }
}

export const NoFeesValues: Record<string, NoFeesValuesType> = {
  [slugs.kingOfKings]: {
    video: 'https://images.angelstudios.com/video/upload/c_scale,h_453/v1744234819/tkok-popcorn-vid-01_vxdwcr.mp4',
    bgColor: '#cbe8f4',
    large: {
      classNames: 'z-[9] right-0',
      gradientWidth: 'w-[250px] lg:w-[215px]',
      gradientHeight: 'lg:!h-[140px] !h-[160px]',
    },
    medium: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[254px]',
      gradientHeight: '!h-[160px]',
    },
    small: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[270px]',
      gradientHeight: '!h-[160px]',
    },
    image:
      'https://images.angelstudios.com/image/upload/v1743712654/king-of-kings/tkok-isolated-waller-willa-img-01.png',
    experimentValues: {
      video: 'https://images.angelstudios.com/video/upload/c_scale,h_453/v1744234819/tkok-popcorn-vid-01_vxdwcr.mp4',
      bgColor: '#bce3ea',
    },
  },
}
